const colors = [
  "#000000", // black
  "#1D2B53", // dark-blue
  "#7E2553", // dark-purple
  "#008751", // dark-green
  "#AB5236", // brown
  "#5F574F", // dark-grey
  "#C2C3C7", // light-grey
  "#FFF1E8", // white
  "#FF004D", // red
  "#FFA300", // orange
  "#FFEC27", // yellow
  "#00E436", // green
  "#29ADFF", // blue
  "#83769C", // lavender
  "#FF77A8", // pink
  "#FFCCAA", // light-peach
];

export default colors;
